import AddContactModal from '../deal/modal/contact/add_contact';
import CardWrapper from '../wrapper/card';
import { createSelector } from 'reselect';
import DeleteContactModal from '../deal/modal/contact/delete_contact';
import { deleteContactThunk } from '../../redux/thunks/contact';
import LabelWrapper from '../wrapper/label';
import { settingSelectedContact } from '../../redux/slices/contact';
import { useParams } from 'react-router';
import { useState } from 'react';
import { AddCircleOutline, DeleteOutlined, EditOutlined, List } from '@mui/icons-material';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, CircularProgress, Divider, IconButton, Typography } from '@mui/material';
import { ContactObject, DeleteContactParams } from '../../params/redux/contact';
import { useDispatch, useSelector } from 'react-redux';

const selectContacts = ((state: RootState) => state.contact.contacts);
const contactLoaders = ((state: RootState) => state.contact.loaders);
const selectSelectedDealDetail = ((state: RootState) => state.deal.selectedDeal);


const selectContactsAndDeal = createSelector(
    [selectContacts, selectSelectedDealDetail, contactLoaders],
    (contactsResult, selectedDealResult, contactLoader) => ({
        contacts: contactsResult,
        selectedDeal: selectedDealResult,
        loaders: contactLoader
    })
);

const ContactsComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const { contacts, selectedDeal, loaders } = useSelector(selectContactsAndDeal);
    const [isAddingContact, setisAddingContact] = useState<boolean>(false);
    const [isDeleting, setIsDeleting] = useState<boolean>(false);
    const [selectedContactDetails, setSelectedContactDetails] = useState<{ contact_id: number, deal_id: number } | null>(null);
    const deleteContactHandler = async () => {
        try {
            const data: DeleteContactParams = {
                deal_id: selectedDeal?.id as number,
                client_id: id ? parseInt(id as string, 10) : 0,
                contact_id: selectedContactDetails?.contact_id as number
            };
            // if (id) {
            //     await dispatch(deleteClientContactThunk(data)).unwrap();
            // } else {
                await dispatch(deleteContactThunk(data)).unwrap();
            // }
            setIsDeleting(false);
        } catch (e) {
            // Catch errors
        }
    };

    const deleteHandler = (contact: ContactObject) => {
        dispatch(settingSelectedContact(contact));
        setIsDeleting(true);
        setSelectedContactDetails({
            contact_id: contact.id,
            deal_id: selectedDeal?.id as number
        });
    };
    const editHandler = (contact: ContactObject) => {
        dispatch(settingSelectedContact(contact));
        setisAddingContact(true);
    };

    const onModalCloseHandler = () => {
        setisAddingContact(false);
        setIsDeleting(false);
        dispatch(settingSelectedContact(null));
    };

    if (loaders.isLoading) {
        return <CardWrapper minHeight="250px">
            <Box display="flex" alignItems="center" flexDirection="column" height="250px" justifyContent="center">
                <CircularProgress />
                <Typography variant="body2">Loading...</Typography>
            </Box>
        </CardWrapper>;
    }

    return (
        <CardWrapper minHeight="250px">
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <Typography variant="h6" color="textSecondary">Contacts</Typography>
                <Box><Button variant="outlined" startIcon={<AddCircleOutline />} onClick={() => setisAddingContact(true)}>
                    Add Contact
                </Button></Box>
            </Box>
            <Divider />
            {
                contacts.length === 0
                    ? <Box my={1}>
                        <LabelWrapper label="No contacts to display" />
                        <List color="info" fontSize="large" /></Box>
                    : (contacts || [])?.map((contact: ContactObject, index: number) => (
                        <Box key={index} display="flex" justifyContent="space-between" alignItems="center" marginTop="10px" my={1}>
                            <Box>
                                <Typography variant="subtitle1" color={contact.contact_name ? 'primary' : 'error'} fontWeight={600}>{contact.contact_name || 'Contact Name is Empty'}</Typography>
                                <Typography variant="subtitle2" color="primary">
                                    {contact.contact_number || 'Phone Number is empty'}
                                </Typography>
                            </Box>
                            <Box>
                                <IconButton color="primary"><EditOutlined onClick={() => editHandler(contact)} /></IconButton>
                                <IconButton color="error"><DeleteOutlined onClick={() => deleteHandler(contact)} /></IconButton>
                            </Box>
                        </Box>
                    ))
            }
            {isAddingContact && <AddContactModal open={isAddingContact} onClose={onModalCloseHandler} />}
            {isDeleting && <DeleteContactModal open={isDeleting} onClose={onModalCloseHandler} onConfirm={deleteContactHandler} />}
        </CardWrapper>);
};

export default ContactsComponent;